<div class="unsupported-viewer">
  <i class="fa-solid fa-file-circle-question"></i>
  <h3>No se puede previsualizar este archivo</h3>
  <p *ngIf="fileName">{{ fileName }}</p>
  <p class="hint">El formato del archivo no es compatible con la vista previa. Descárgalo para abrirlo.</p>
  <button pButton pRipple type="button" *ngIf="fileUrl"
          label="Descargar archivo"
          icon="pi pi-download"
          class="p-button-primary"
          (click)="onDownload()">
  </button>
</div>
